import { PageGeneral } from "types/CMS/KontentAI/content-types";
import { urlHierarchyTraversal } from "./urlHierarchy";
import { generalSectionResolver } from "./generalSection";
import { assetResolver } from "./asset";
import { generalPage } from "types/CMS/Unum/GeneralPage/generalPage";
import { heroTypeResolver } from "./heroType";
import { richTextResolver } from "./richText";
import { createResolver } from "./Factories/ResolverFactory";
import { KontentFilterInputs } from "types/CMS/Unum/filterable";

export const generalPagesResolver = (
  data: PageGeneral[] | PageGeneral,
  filters?: KontentFilterInputs
) => {
  if (Array.isArray(data)) {
    return data.map(
      (item) => GeneralPageResolver.resolve(item, filters).result
    );
  }
  return [GeneralPageResolver.resolve(data, filters).result];
};

export const GeneralPageResolver = createResolver({
  resolve: (data: PageGeneral, filters): generalPage | undefined => {
    if (!data) {
      return undefined;
    }

    const { elements } = data;

    return {
      type: "generalPage",
      page: {
        type: "generalPageInfomation",
        url_slug: elements.url_slug.value,
        meta_description: elements.page_elements__meta_description.value,
        meta_title: elements.page_elements__meta_title.value,
        urlPath: urlHierarchyTraversal(data),
      },

      heroBanner: {
        type: "heroBanner",
        title: elements.title.value,
        image: assetResolver.resolve(elements.image.linkedItems?.[0]).result,
        intro: richTextResolver.resolve(elements.intro).result,
        heroType: heroTypeResolver.resolve(elements.hero_type.value[0].codename)
          .result,
      },

      sections: generalSectionResolver.resolve(
        elements.sections.linkedItems,
        filters
      ).result,
    };
  },
});